function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.18,17.2a.69.69,0,0,1,.69-.77H23a.75.75,0,0,1,.72.64.7.7,0,0,1-.7.77h-8.1A.72.72,0,0,1,14.18,17.2Zm9.51,2.94A.74.74,0,0,0,23,19.5h-8.1a.69.69,0,0,0-.69.77.72.72,0,0,0,.71.64H23A.71.71,0,0,0,23.69,20.14ZM44,22A22,22,0,1,1,22,0,22,22,0,0,1,44,22ZM14.8,25a7.45,7.45,0,0,0,4.13,1.24,7.55,7.55,0,1,0-6.66-4,.7.7,0,0,1,.08.45l-.45,2.54a.23.23,0,0,0,.29.26l2-.57a.63.63,0,0,1,.19,0A.74.74,0,0,1,14.8,25Zm17.81-4.32a.38.38,0,0,0-.38-.39H27.75a9,9,0,0,1-8.82,7.35,10.22,10.22,0,0,1-1.35-.1v1.27a.38.38,0,0,0,.39.38h9a.71.71,0,0,1,.61.36l1,1.71a.25.25,0,0,0,.43,0l1-1.71a.74.74,0,0,1,.61-.36h1.65a.37.37,0,0,0,.38-.38Z"
});

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.59362366.svg";
export { ForwardRef as ReactComponent };